const WINDOW_MS = 60_000;
const MAX_SAMPLES = 500;

interface Sample {
  ts: number;
  ms: number;
}

const samples: Sample[] = [];

export function recordLatencySample(ms: number, ts: number = Date.now()): void {
  if (!Number.isFinite(ms) || ms < 0) return;
  samples.push({ ts, ms });
  if (samples.length > MAX_SAMPLES) samples.splice(0, samples.length - MAX_SAMPLES);
}

export function getLatencyP50(now: number = Date.now()): number | null {
  const cutoff = now - WINDOW_MS;
  while (samples.length > 0) {
    const head = samples[0];
    if (head && head.ts >= cutoff) break;
    samples.shift();
  }
  if (samples.length === 0) return null;
  const sorted = samples.map((s) => s.ms).sort((a, b) => a - b);
  const idx = Math.floor(sorted.length / 2);
  return sorted[idx] ?? null;
}

export function _resetLatencyBufferForTests(): void {
  samples.length = 0;
}
